import React from "react"
import PropTypes from "prop-types"
import DiscreteSelectPDFWrapper from "app/static/frontend/components/DiscreteSelectPDFWrapper"
import PDFViewer from "app/static/frontend/components/PDFViewer"
import "app/static/stylus/TextWithTabs.styl"

export const ProfileAboutMessage = ({
    isPDF,
    messageText,
    displayFullPDFHeight,
    isMultiLanguagePDF,
    languageUrls,
    hasDiscreteSelect,
    discreteSelectOptions,
    getDefault,
    formatOptions,
    getUrl,
}) => (
    <div className={`about-message-container ${displayFullPDFHeight ? "full-pdf-height" : "default-height"}`}>
        {isPDF && (isMultiLanguagePDF || hasDiscreteSelect) ? (
            <DiscreteSelectPDFWrapper
                className={`about-message ${displayFullPDFHeight ? "full-pdf-height" : "default-height"}`}
                options={isMultiLanguagePDF ? languageUrls : discreteSelectOptions}
                getDefault={getDefault}
                formatOptions={formatOptions}
                getUrl={getUrl}
            />
        ) : isPDF ? (
            <PDFViewer
                className={`about-message ${displayFullPDFHeight ? "full-pdf-height" : "default-height"}`}
                url={messageText}
                key={messageText}
            />
        ) : (
            <div className="about-message" dangerouslySetInnerHTML={{ __html: messageText }} />
        )}
    </div>
)

export default ProfileAboutMessage
